import { SpecialHispanic } from "./special-hispanic/special-hispanic";
import { PilotoRNBP } from "./piloto-rnbp/piloto-rnbp";
import { AboutMkMk } from "./about-mkmk/about-mkmk";

export const Landings = {
    SpecialHispanic,
    PilotoRNBP,
    AboutMkMk
}
